'use client';

import Image from 'next/image';
import { useState } from 'react';
import { DEFAULT_IMAGE, DEFAULT_IMAGE_BASE64 } from 'constants/index';
import * as El from './OrganizerCard.css';

interface LogoUrls {
  original?: string;
  lg?: string;
  xs?: string;
}

interface OrganizerCardProps {
  isItem?: boolean;
  logo: LogoUrls;
  name: string;
  href?: string;
  sectionPosition?: string;
  dataCreative?: string;
  loadingImage?: 'lazy' | 'eager';
}

function OrganizerCard({
  isItem = false,
  logo = { original: '' },
  name = '',
  href = '#',
  sectionPosition = '',
  dataCreative = '',
  loadingImage = 'eager',
}: OrganizerCardProps) {
  const [isLoading, setIsLoading] = useState(true);

  const isItemString = isItem ? 'true' : 'false';
  return (
    <a
      className={`${El.cardContainer[isItemString]} sympla-organizer-card`}
      id="organizer-card"
      href={href}
      title={name}
      aria-label={name}
      data-name={name}
      data-position={sectionPosition}
      data-creative={dataCreative}
    >
      <div className={El.contentWrapper[isItemString]}>
        <div className={El.imageContainer[isItemString]}>
          <Image
            className={El.organizerImage[isLoading ? 'true' : 'false']}
            alt={`Logo ${name}`}
            src={logo.lg || logo.original || logo.xs || DEFAULT_IMAGE}
            width={100}
            height={104}
            loading={loadingImage}
            priority={loadingImage === 'eager'}
            sizes="(max-width: 640px) 50vw, (max-width: 830px) 70px, 64px"
            onLoad={() => {
              setIsLoading(false);
            }}
            placeholder="blur"
            blurDataURL={DEFAULT_IMAGE_BASE64}
          />
        </div>

        <div className={El.organizerInfo}>
          <div className={`${El.nameWrapper[isItemString]} animated fadeIn`}>
            <div className={El.organizerName}>{name}</div>
          </div>
        </div>
      </div>
    </a>
  );
}

export default OrganizerCard;
